import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { FileAttributes, MediaTraceContext } from '@atlaskit/media-common/analytics/types';

import { MediaCardError } from '../MediaCardError';
import { type CardStatus } from '../types';
import type { SSRStatus } from '../utils/analytics/analytics';
import { fireMediaCardEvent } from '../utils/analytics/fireMediaCardEvent';
import { getErrorEventPayload } from '../utils/analytics/getErrorEventPayload';

export const fireNonCriticalErrorEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	cardStatus: CardStatus,
	fileAttributes: FileAttributes,
	ssrReliability: SSRStatus,
	error: MediaCardError | undefined = new MediaCardError('missing-error-data'),
	traceContext: MediaTraceContext,
	metadataTraceContext?: MediaTraceContext,
): void => {
	const errorPayload = getErrorEventPayload(
		cardStatus,
		fileAttributes,
		error,
		ssrReliability,
		traceContext,
		metadataTraceContext,
	);

	fireMediaCardEvent(errorPayload, createAnalyticsEvent);
};
